module.exports = __webpack_public_path__ + "static/img/tx.964f813d.svg";